import Logo from "@/components/Logo";

export default function PublicFooter() {
  return (
    <footer className="border-t border-[#222530] bg-[#050506]" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div className="space-y-4">
            <Logo />
            <p className="text-sm text-[#64748B] leading-relaxed max-w-xs">
              A private trading ecosystem engineered for elite performance. Access is
              exclusively referral-based through authorized PLUSMAKER partners.
            </p>
          </div>
          <div>
            <p className="eyebrow-label mb-4">Ecosystem</p>
            <ul className="space-y-2.5 text-sm text-[#94A3B8]">
              <li><a href="#about" className="hover:text-white transition-colors" data-testid="footer-link-about">About Us</a></li>
              <li><a href="#rewards" className="hover:text-white transition-colors" data-testid="footer-link-rewards">Rewards</a></li>
              <li><a href="#products" className="hover:text-white transition-colors" data-testid="footer-link-products">Products</a></li>
              <li><a href="#ai" className="hover:text-white transition-colors" data-testid="footer-link-ai">PlusMaker AI</a></li>
            </ul>
          </div>
          <div>
            <p className="eyebrow-label mb-4">Access</p>
            <ul className="space-y-2.5 text-sm text-[#94A3B8]">
              <li><a href="/login" className="hover:text-white transition-colors" data-testid="footer-link-login">Member Login</a></li>
              <li><a href="/register" className="hover:text-white transition-colors" data-testid="footer-link-register">Register</a></li>
            </ul>
          </div>
          <div>
            <p className="eyebrow-label mb-4">Legal</p>
            <ul className="space-y-2.5 text-sm text-[#94A3B8]">
              <li><a href="/privacy" className="hover:text-white transition-colors" data-testid="footer-link-privacy">Privacy Policy</a></li>
              <li><a href="/terms" className="hover:text-white transition-colors" data-testid="footer-link-terms">Terms of Service</a></li>
              <li><a href="/deletion" className="hover:text-white transition-colors" data-testid="footer-link-deletion">Account Deletion</a></li>
              <li><a href="/lucky-draw-rules" className="hover:text-white transition-colors" data-testid="footer-link-lucky-draw-rules">Lucky Draw Rules</a></li>
            </ul>
          </div>
        </div>

        <div className="gold-divider my-10" />

        <p className="text-xs text-[#64748B] leading-relaxed max-w-4xl" data-testid="footer-risk-disclaimer">
          Risk Disclaimer: Trading foreign exchange, commodities, and CFDs carries a high
          level of risk and may not be suitable for all investors. Past performance is not
          indicative of future results. You should never trade with capital you cannot
          afford to lose. PLUSMAKER provides tooling and education — not financial advice.
        </p>
        <p className="text-xs text-[#475569] mt-6">
          © {new Date().getFullYear()} PLUSMAKER. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
